module.exports = __webpack_public_path__ + "static/img/DINProBold.cb4466e0.svg";